import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  lookingForChallengePrompt: {
    id: 'WidgetSidebar.lookingForChallengePrompt',
    defaultMessage: 'Looking for a new challenge?',
    description: 'Prompt user for new challenge',
  },
  findCoursesButton: {
    id: 'WidgetSidebar.findCoursesButton',
    defaultMessage: 'Find a course {arrow}',
    description: 'Button to explore more courses',
  },
});

export default messages;
